module.exports = __webpack_public_path__ + "img/dapp.f6412e68.png";